module.exports = __webpack_public_path__ + "static/media/lines-fisk.7b624d0f.svg";